export var RETAILER_BUCKETED_INTO_UK_EU_BRANDS_FREE_SHIPPING_EXPERIMENT = 'RETAILER_BUCKETED_INTO_UK_EU_BRANDS_FREE_SHIPPING_EXPERIMENT';
